import React, { useState, useEffect, useContext } from 'react'
import { AlertList, PanelTitle, SimpleRows, StatCard, WeeklyConsumptionChart } from './InventoryShared';
import axios from 'axios';
import { DBContext } from '../DBContext';
import { MdDinnerDining, MdLocalFireDepartment } from 'react-icons/md';

function DailyProductionWidget({ navigate }) {
    const { logginedDB } = useContext(DBContext);
    const [items, setItems] = useState([]);
    const [settings, setSettings] = useState(null);
    const BASE = process.env.REACT_APP_API_BASE_URL;
    useEffect(() => {
        if (!logginedDB) return;
        axios.get(`${BASE}/production/today/${logginedDB}`)
            .then(r => setItems(r.data.data || []))
            .catch(() => { });
        axios.get(`${BASE}/production/settings/${logginedDB}`)
            .then(r => setSettings(r.data.settings || {}))
            .catch(() => { });
    }, [logginedDB]);

    const lowItems = items.filter(i => i.available_qty > 0 && i.available_qty <= i.low_threshold);
    const soldOut = items.filter(i => i.available_qty <= 0);

    const formatTime12Hr = (timeStr) => {
        if (!timeStr) return '';
        const parts = timeStr.split(':');
        let hour = parseInt(parts[0]) || 0;
        const minute = parts[1] || '00';
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12;
        return `${hour}:${minute} ${ampm}`;
    };

    return (
        <section className="inventory-panel" style={{ gridColumn: 'span 2' }}>
            <div className="inventory-panel-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '.1rem' }}>
                    <span style={{ fontWeight: 600 }}>Today's Production Status</span>
                    {settings && settings.reset_mode === 'AUTO' && settings.closing_time && (
                        <span style={{ fontSize: '.75rem', color: '#6b7280', fontWeight: 400 }}>
                            Closing Cutoff: <strong style={{ color: '#c2410c' }}>{formatTime12Hr(settings.closing_time)}</strong>
                        </span>
                    )}
                </div>
                <button onClick={() => navigate('/Inventory/daily-production')}>Manage</button>
            </div>
            {items.length === 0 ? (
                <div className="inventory-empty-panel">
                    <MdDinnerDining size={32} color="#dadada" />
                    <p style={{ margin: '.4rem 0 .75rem', fontSize: '.88rem' }}>No production batches set today.</p>
                    <button onClick={() => navigate('/Inventory/daily-production')} style={{ fontSize: '.82rem', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: '.313rem', padding: '.35rem .75rem', cursor: 'pointer' }}>Add Batch</button>
                </div>
            ) : (
                <div style={{ padding: '.5rem .75rem .75rem', display: 'flex', flexWrap: 'wrap', gap: '.5rem' }}>
                    {soldOut.length > 0 && (
                        <div style={{ width: '100%', padding: '.4rem .75rem', background: '#fef2f2', borderRadius: '.313rem', color: '#dc2626', fontSize: '.85rem', fontWeight: 600 }}>
                            ⛔ {soldOut.length} item{soldOut.length > 1 ? 's' : ''} sold out: {soldOut.map(i => i.item_name).join(', ')}
                        </div>
                    )}
                    {lowItems.length > 0 && (
                        <div style={{ width: '100%', padding: '.4rem .75rem', background: '#fffbeb', borderRadius: '.313rem', color: '#d97706', fontSize: '.85rem', fontWeight: 600 }}>
                            ⚠️ Low stock: {lowItems.map(i => `${i.item_name} (${i.available_qty})`).join(', ')}
                        </div>
                    )}
                    {items.filter(i => i.available_qty > i.low_threshold).map(i => (
                        <span key={i.id} style={{ padding: '.2rem .6rem', background: '#f0fdf4', borderRadius: '9999px', fontSize: '.8rem', color: '#16a34a', fontWeight: 600 }}>
                            ✓ {i.item_name}: {i.available_qty}
                        </span>
                    ))}
                </div>
            )}
        </section>
    );
}

function InventoryDashboard({ data, stats, navigate }) {
    return (
        <div className='inventory-dashboard'>
            <div className='inventory-overview-row'>
                <div className='inventory-overview-left'>
                    <div className='inventory-stat-grid'>
                        <StatCard title='Total Items' value={Math.round(stats.totalItems)} note='Overall stock count' />
                        <StatCard title='Low Stock' value={`${stats.lowStock} Items`} note='Below reorder threshold' />
                        <StatCard title='Out of Stock' value={String(stats.outOfStock).padStart(2, '0')} note='Needs urgent purchase' />
                        <StatCard title='Purchase Orders' value={stats.purchaseOrders} note='Ongoing / pending' />
                    </div>
                    <div className='inventory-action-row'>
                        {/* <button onClick={() => navigate('/Inventory/purchase-entry')}>Add Stock</button>
                        <button onClick={() => navigate('/Inventory/stock-transfer')}>Transfer Stock</button>
                        <button onClick={() => navigate('/Inventory/wastage-entry')}>Wastage Entry</button> */}
                        <button onClick={() => navigate('/Inventory/daily-production')} style={{ background: '#7c3aed', borderColor: '#7c3aed' }}>
                            <MdDinnerDining style={{ verticalAlign: 'middle', marginRight: '.3rem' }} />Daily Production
                        </button>
                        <button onClick={() => navigate('/Inventory/trends')} style={{ background: '#ff6b00', borderColor: '#ff6b00' }}>
                            <MdLocalFireDepartment style={{ verticalAlign: 'middle', marginRight: '.3rem' }} />Trends
                        </button>
                    </div>
                </div>
                <section className='inventory-panel inventory-consumption-panel'>
                    <PanelTitle title='Weekly Consumption Chart' />
                    <WeeklyConsumptionChart data={data.weeklyConsumption} />
                </section>
            </div>
            <div className='inventory-dashboard-grid'>
                {/* <section className='inventory-panel'>
                    <PanelTitle title='Low Stock Alerts' action='View All' onClick={() => navigate('/Inventory/low-stock-alerts')} />
                    <AlertList items={data.items.filter(item => item.currentStock <= item.threshold)} />
                </section>
                <section className='inventory-panel'>
                    <PanelTitle title='Quick Stock Preview' action='Stock List' onClick={() => navigate('/Inventory/stock-list')} />
                    <SimpleRows rows={data.items.slice(0, 4)} columns={['name', 'currentStock', 'unit', 'status']} empty='No stock found.' />
                </section> */}
                <DailyProductionWidget navigate={navigate} />
            </div>
        </div>
    );
}

export default InventoryDashboard
